/** Takes care of inserting header with authentication token for all HTTP requests going to our APIs
 */
import {Injectable} from "@angular/core";
import {StateService} from "../services/state.service";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {PathService} from '../services/path.service';
import {SessionService} from '../services/session.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private state: StateService,
                private sessionService: SessionService,
                private pathService: PathService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // If we already have a token and the URL is for an API call, then add the token header (whether the API call needs it
        // or not, it can't hurt).
        // Also use this time to update the local session expiration timer
        const token = this.state.get('authToken');
        if (token && req.url.startsWith(`${this.pathService.apiRoot}/`)) {
            this.sessionService.restartSession();
            req = req.clone({
                    setHeaders: {
                        'X-Authorization': `Bearer ${token}`
                    }
                }
            );
        }
        return next.handle(req);
    }
}
